module.exports = __webpack_public_path__ + "img/tech_mob.65b7200.webp";